<template>
  <div class="">
    <section class="header-menu-container navbar navbar-expand-md fixed-top">
      <img class="zyrl-logo" src="./assets/branding/revi-logo.png" />
    </section>
    <div class="page-body">
      <section class="container-fluid">
        <router-view />
      </section>
    </div>
  </div>
</template>

<style>
#app {
  display: block;
  height: 100%;
  width: 100%;
  margin: 0;
  padding: 0;
}

/* === START === General CSS */

html {
  scroll-behavior: smooth;
}

body {
  font-family: "Manrope", sans-serif;
  height: 100%;
  width: 100%;
}

.page-body .row {
  padding-bottom: 16px !important;
}

h1,
h2,
h3,
h4,
h5,
h6,
.h1,
.h2,
.h3,
.h4,
.h5,
.h6 {
  font-family: "Manrope", sans-serif;
  margin-bottom: 0px;
}

h1,
.h1 {
  /* font-size: 2.222vw; */
  font-size: calc(32px + (12) * ((100vw - 1200px) / (1980 - 1200)));
  color: #5471fa;
  font-weight: 600;
}

h2,
.h2 {
  font-size: calc(18px + (12) * ((100vw - 1200px) / (1980 - 1200)));
  /* font-size: 30px; */
  color: #00000f;
  font-weight: 600;
  margin-bottom: 0.75em;
}

h3,
.h3 {
  font-size: calc(18px + (4) * ((100vw - 1200px) / (1980 - 1200)));
  color: #00000f;
  font-weight: 600;
}

h4,
.h4 {
  /* font-size: 0.990vw; */
  /* font-size: 19px; */
  font-size: calc(12px + (7) * ((100vw - 1200px) / (1980 - 1200)));
  color: #00000f;
  font-weight: 700;
}

h5,
.h5 {
  /* font-size: 0.729vw; */
  /* font-size: 14px; */
  font-size: calc(9px + (5) * ((100vw - 1200px) / (1980 - 1200)));
  color: #bcbec6;
  font-weight: 400;
  text-transform: uppercase;
}

h6,
.h6 {
  /* font-size: 19px; */
  font-size: calc(12px + (7) * ((100vw - 1200px) / (1980 - 1200)));
}

p {
  font-family: "Manrope", sans-serif;
  /* font-size: 0.990vw; */
  /* font-size: 19px; */
  font-size: calc(12px + (7) * ((100vw - 1200px) / (1980 - 1200)));
  color: #00000f;
  font-weight: 400;
}

p.bold {
  font-family: "Manrope", sans-serif;
  /* font-size: 0.990vw; */
  /* font-size: 19px; */
  font-size: calc(12px + (7) * ((100vw - 1200px) / (1980 - 1200)));
  color: #00000f;
  font-weight: 700;
}

small,
.small {
}

a {
  color: #5471fa;
}

a:active,
a:hover {
}

.header-menu-container {
  /* height: 120px; */
  height: 0;
  /*height: calc(75px + (45) * ((100vh - 675px) / (1080 - 675)));*/
  /*padding-left: 36px;*/
  /*padding-right: 110px;*/
  display: flex;
  /*justify-content: space-between;*/
  background-color: transparent;
  border: 0px solid #dfe2ed;
}

.zyrl-logo {
  min-height: 45px;
  height: calc(0.5 * calc(75px + (45) * ((100vh - 675px) / (1080 - 675))));
  width: auto;
  margin-right: auto;
  margin-top: 100px;
}

button,
.dashboard-link {
  /* height: 64px; */

  background-color: #ff4f21;
  color: #fff;
  font-weight: 600;
  min-height: 6vh;
  font-size: 1.146vw;
  /* padding: 16px 20px; */
  padding: 1.5vh 2vh;
  /* border-radius: 6px; */
  border-radius: 0.5vh;
  border: 0px solid #f89e1f;
  width: fit-content;
  box-shadow: 0px 1px 3px #00000033;
}

.back-button {
  color: #bfc4cd;
  background-color: transparent !important;
  box-shadow: none;
}

button.dark-button {
  background-color: #0a1e42;
}

button:hover {
  cursor: pointer;
}

button:focus {
  outline: 0px solid #000;
}

/* = START = Button & Input Styling */

/* END - Button & Input Styling */

/* END - General CSS */

/* START - TRANSITIONS */

.ease {
  -webkit-transition: all 0.3s ease-in-out;
  -moz-transition: all 0.3s ease-in-out;
  -ms-transition: all 0.3s ease-in-out;
  -o-transition: all 0.3s ease-in-out;
}
.page-body {
  /*margin-top: calc(75px + (45) * ((100vh - 675px) / (1080 - 675)));*/
  min-height: calc(100vh);
  background-color: #f6f7fb;
  /*overflow-y: scroll;*/
  padding-top: 7vh;
  padding-bottom: 7vh;
}

@keyframes pulse {
  0% {
    transform: scale(1);
  }

  70% {
    transform: scale(1.25);
  }

  100% {
    transform: scale(1);
  }
}

/* END - TRANSITIONS */

#zyrl-example-col {
  font-family: "Manrope", sans-serif;
  font-size: 20px;
  font-weight: bold;
  line-height: 1.1;
  color: #fff;
  border-radius: 10px;
}

section#zyrl-example-col {
  background-color: #008bdb;
  padding: 24px;
}

#zyrl-example-col .row {
  background-color: #00c3aa;
  padding: 24px;
  border-radius: 10px;
  margin: 6px 6px;
}

#zyrl-example-col .row div {
  background-color: #333;
  padding: 24px 0;
  border-radius: 10px;
}

/* END - Section #zyrl-example-col */

/* DATE PICKER CSS */

.section-title-duration .dropdown {
  /* height: 100%; */
  display: flex;
  flex-direction: column;
  justify-content: center;
}

i#dropdownMenuButton {
  height: 100% !important;
  display: block;
  /* padding-top: 20px;
    padding-bottom: 20px; */

  padding: 1.25em 0em;
}

.date-picker input {
  width: 125px;
}

.date-picker input[type="text"] {
  text-align: center !important;
}

.vdp-datepicker.date-picker.start .vdp-datepicker__calendar {
  /* display: block !important; */
  top: 44px;
  left: -9px;
}

.vdp-datepicker.date-picker.end .vdp-datepicker__calendar {
  /* display: block !important; */
  top: 44px;
  left: -164px;
}

/* START - OLD Mobile CSS */
/* https://getbootstrap.com/docs/4.0/layout/overview/ */

/* @media (max-width: 1199.98px) {

  .page-content-body {
    width: 100% !important;
    height: calc(100% - 64px) !important;
  }

  .page-body {
    width: 100% !important;
  }

  .orange-block {
    height: 175px !important;
  }

  .orange-block h1 {
    text-align: center;
    font-size: 28px;
    padding-top: 18px !important;
  }

  .full-name {
    display: none !important;
  }

  .profile-image img {
    padding: 0 0 !important;
  }

  .account-setting {
    padding: 0 0 0 0 !important;
  }

  .greeting {
    padding: 0 0 0 16px !important;
  }

  .greeting h4 {
    font-size: 16px;
  }

  .page-body .row>div {
    padding-bottom: 16px !important;
  }
} */

/* END - Old Mobile CSS */

/* START - SEARCH & FILERS */

.search-filters-container {
  padding: 0px;
}

.form-group {
  /* margin-bottom: 24px; */
  margin-bottom: 3vh;
}

input.form-control {
  /* border: 1px solid #0A1E42; */
  border: 1px solid rgba(10, 30, 66, 0.5);
  /* border-radius: 4px; */
  /* font-size: 16px; */
  height: fit-content;
  /* padding: 16px 16px; */
  /* color: #00000099; */
  color: #0a1e42 !important;

  height: 6vh;
  font-size: 1.146vw;
  /* padding: 16px 20px; */
  padding: 1.5vh 1.8vh;
  /* border-radius: 6px; */
  border-radius: 0.5vh;
  font-size: 1rem;
}

input,
option,
textarea,
input:focus,
option:focus {
  outline: none !important;
  box-shadow: none !important;

  height: 6vh;
  font-size: 1.146vw;
  /* padding: 16px 20px; */
  padding: 1.5vh 1.8vh;
  /* border-radius: 6px; */
  border-radius: 0.5vh;
  font-size: 1rem;
}

input:focus,
textarea:focus,
option:focus {
  border: 1px solid #eb3e16 !important;
}

.search-filters-container input {
  font-size: calc(12px + (7) * ((100vw - 1200px) / (1980 - 1200)));
  padding: 1em 1em;
  color: #5471fa;
  background-color: #fff;
  border: 1px solid #dfe2ed;
  border-radius: 6px;
  /* padding: 18px 55px 18px 28px; */
}

.search-filters-container input:focus {
  border: 1px solid #ff4f21;
  /* font-size: 19px; */
  font-size: calc(12px + (7) * ((100vw - 1200px) / (1980 - 1200)));
  padding: 1em 1em;
  color: #5471fa;
  outline: none;
}

.calendar {
  margin-left: 16px;
  width: fit-content;
  font-size: calc(12px + (7) * ((100vw - 1200px) / (1980 - 1200)));
  padding: 0em 1em;
  color: #5471fa;
  border-radius: 6px;
  background-color: #fff;
  border: 1px solid #dfe2ed;
  /* padding: 1px 16px; */
}

.calendar i {
  padding: 0px;
  font-size: calc(12px + (7) * ((100vw - 1200px) / (1980 - 1200)));
  /* padding: 0em 1em; */
}

/* END - SEARCH & FILERS */

.sub-text {
  /* margin-bottom: 1.25rem; */
  margin-bottom: 4vh;
  color: #00000099;
}

/* ========================================== */
/* ======== START - RESPONSIVE CSS ========== */

/* Fluid Sizing */
/* font-size: calc([minimum size] + ([maximum size] - [minimum size]) * ((100vw - [minimum viewport width]) / ([maximum viewport width] - [minimum viewport width]))); */

/* Small Screens & Mobile Devices (portrait phones, less than 576px) */
@media (max-width: 1199.99px) {
  .desktop-only {
    display: none !important;
  }

  h1,
  .h1 {
    font-size: calc(27px + (37) * ((100vw - 320px) / (1080 - 320)));
  }

  h2,
  .h2 {
    font-size: calc(20px + (6) * ((100vw - 320px) / (1080 - 320)));
  }

  h3,
  .h3 {
  }

  h4,
  .h4 {
  }

  h5,
  .h5 {
    font-size: calc(11px + (15) * ((100vw - 320px) / (1080 - 320)));
  }

  h6,
  .h6 {
  }

  p {
    font-size: calc(12px + (15) * ((100vw - 320px) / (1080 - 320)));
  }

  p.bold {
    font-size: calc(12px + (15) * ((100vw - 320px) / (1080 - 320)));
  }

  button,
  .dashboard-link {
    font-size: calc(19px + (7) * ((100vw - 320px) / (1080 - 320)));
  }

  .tooltip-container img {
    height: 48px;
  }

  .s50 {
    width: 50% !important;
    padding-left: 0px;
    padding-right: 0px;
  }

  /* START - SEARCH & FILERS */
  .search-filters-container input {
    font-size: calc(11px + (15) * ((100vw - 320px) / (1080 - 320))) !important;
    padding: 1em 1em;

    color: #5471fa;
    background-color: #fff;
    border: 1px solid #dfe2ed;
    border-radius: 6px;
  }

  .search-filters-container input:focus {
    border: 1px solid #ff4f21;
    font-size: calc(11px + (15) * ((100vw - 320px) / (1080 - 320))) !important;
  }

  .calendar {
    margin-left: 16px;
    width: fit-content;
    font-size: 19px;
    color: #5471fa;
    border-radius: 6px;
    background-color: #fff;
    border: 1px solid #dfe2ed;
    padding: 1px 16px;
  }

  .calendar i {
    padding: 0px;
    font-size: calc(11px + (15) * ((100vw - 320px) / (1080 - 320))) !important;

    padding: 1em 1em;
  }

  .date-picker-container {
    background: #ffffff;
    -webkit-box-shadow: 0px 2px 8px #4060e324;
    box-shadow: 0px 2px 8px #4060e324;
    border-radius: 6px;
    border: 0px;
    padding: 6px 6px !important;
    margin: 0px !important;
    height: fit-content;
    position: absolute;
    top: 48px !important;
    left: -270px !important;
  }

  /* END - SEARCH & FILERS */
  .white-box {
    background: #fff;
    border-radius: 6px;
    box-shadow: 4px 5px 15px #0a1e4217;
    padding: 24px 18px !important;
  }

  .header-menu-container {
    height: 60px;
    padding-left: 0;
    padding-right: 0px;
    display: flex;
    justify-content: space-between;
    background-color: #fff;
    border: 1px solid #dfe2ed;
  }

  .zyrl-logo {
    height: 45px;
    margin-left: auto;
    margin-right: auto;
    margin-top: 0px;
  }

  .page-body {
    margin-top: 60px;
    min-height: calc(100vh);
    /*overflow-y: scroll;*/
    padding-left: 8px;
    padding-right: 8px;
  }
}

/* Extra large devices (large desktops, 1200px and up) */
@media (min-width: 1200px) {
  .white-box {
    background: #fff;
    border-radius: 6px;
    box-shadow: 4px 5px 15px #0a1e4217;
    padding: 1.875vw 2.5vw !important;
    padding: 36px 48px 36px 48px;
  }

  .mobile-only {
    display: none;
  }

  .col-center {
    width: 696px;
  }

  .tooltip-container img {
    height: calc(48px + (-22) * ((100vw - 320px) / (1080 - 320))) !important;
  }

  .search-filters-container input {
    font-size: 19px;
    color: #5471fa;
    background-color: #fff;
    border: 1px solid #dfe2ed;
    border-radius: 6px;
    /* padding: 18px 55px 18px 28px; */
    /* padding: 1em 2em 1em 1.5em !important; */
  }

  .side-bar {
    width: calc(250px + (70) * ((100vw - 1200px) / (1980 - 1200)));
    height: 100%;
  }

  .content-body {
    width: calc(
      100% - (calc(250px + (70) * ((100vw - 1200px) / (1980 - 1200))))
    );
    height: calc(100vh - 120px);
    background-color: #f6f7fb;
    padding: calc(37px + (23) * ((100vw - 1200px) / (1980 - 1200)))
      calc(72px + (48) * ((100vw - 1200px) / (1980 - 1200)));
  }
}

/* END of desktop */

/* ========== END - RESPONSIVE CSS ========== */
/* ========================================== */

div.loading-cover {
  z-index: 100;
  position: fixed;
  top: 50%;
  left: 50%;
  /* bring your own prefixes */
  transform: translate(-50%, -50%);
  width: 100%;
  height: 100%;
  background-color: #f6f7fb;
  opacity: 0.8;
  display: flex;
  justify-content: center;
}

.waiting-text {
  color: #ff4f21;
  z-index: 101;
}
</style>
